
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "Actor": [
      "APIKeyV2",
      "AnchorageActor",
      "UnknownActor",
      "UserKey",
      "UserV2"
    ],
    "Button": [
      "BooleanButton"
    ],
    "EEAmount": [
      "Amount",
      "UnsupportedAssetAmount"
    ],
    "EEAssetTypeInfo": [
      "AssetTypeInfo",
      "UnsupportedAssetAssetTypeInfo"
    ],
    "EENetworkInfo": [
      "NetworkInfo",
      "UnsupportedAssetNetworkInfo"
    ],
    "ErrorMessage": [
      "OutstandingHoldsError"
    ],
    "FiatTrustedDestinationIntruction": [
      "FiatTrustedDestinationACHPullAuthorization",
      "FiatTrustedDestinationACHPush",
      "FiatTrustedDestinationInstantTransfer",
      "FiatTrustedDestinationWire"
    ],
    "IAMMember": [
      "IAMMemberUser"
    ],
    "IAMResource": [
      "Organization",
      "Vault"
    ],
    "Initiator": [
      "APIKey",
      "User"
    ],
    "Instruction": [
      "InstantTransferStandingInstruction",
      "WireStandingInstruction"
    ],
    "KYCProfile": [
      "AffiliateKYCProfile",
      "OrganizationKYCProfile",
      "RelatedPartyKYCProfile"
    ],
    "KYCProfileRelation": [
      "AffiliateKYCProfileRelation",
      "KYCProfileRelationAuditRole",
      "RelatedPartyKYCProfileRelation"
    ],
    "Key": [
      "APIKeyV2",
      "UserKey"
    ],
    "Node": [
      "APIKeyV2",
      "AccountConstraint",
      "AccountConstraintGroup",
      "AccountConstraintState",
      "AccountOrganizations",
      "AccountV2",
      "AddressBalance",
      "AffiliateAnchorageRelationship",
      "AffiliateV2",
      "AnchorageLegalEntity",
      "BlockchainAddress",
      "CRRScoreDetails",
      "ClientOrder",
      "ClientPaymentFlow",
      "ClientSettlement",
      "CounterpartyScreeningEntry",
      "DepositAttributionSpamThreshold",
      "DepositAttributionV2",
      "ExternalAccount",
      "ExternalAccountLocation",
      "ExternalAccountTransaction",
      "ExternalScreeningRequest",
      "GlobalTrustedSource",
      "IAMCategory",
      "IAMMemberUser",
      "IAMPermission",
      "IAMRole",
      "IAMUserAccess",
      "IAMUserRole",
      "IndividualAffiliateRelationshipAudit",
      "KYCConfig",
      "KYCProcess",
      "KYCProcessTrigger",
      "KYCQuestion",
      "KYCQuestionnaire",
      "KYCQuestionnaireSubmission",
      "KYCScreeningRequest",
      "KeyInfo",
      "MintBurnConversion",
      "NxtTfcAccount",
      "NxtTfcCycle",
      "NxtTfcPosition",
      "OrganizationModule",
      "PaymentFlow",
      "Person",
      "PolicyFragmentBinding",
      "PolicyQuorum",
      "ReadPolicy",
      "ReadQuorum",
      "Report",
      "ReportDataFilter",
      "ReportDataFilterValue",
      "ReportFile",
      "ReportFileEmailDelivery",
      "ReportFileSftpDelivery",
      "ReportFileSwiftDelivery",
      "ReportFileValidation",
      "ReportFileVerification",
      "ReportSchedule",
      "ReportScheduleDataFilter",
      "ReportScheduleDataFilterValue",
      "ReportScheduleEmailDestination",
      "ReportScheduleFileFormats",
      "ReportScheduleMainFilter",
      "ReportScheduleSftpDestination",
      "ReportScheduleSwiftDestination",
      "ReportTypeDefinition",
      "ReportTypeFilterDefinition",
      "ReportTypeHeader",
      "ReportTypeValidation",
      "SNParticipant",
      "SNTwoWaySettlement",
      "StablecoinRewardsParticipant",
      "TaxDocument",
      "TaxMapping",
      "TokenSwap",
      "TrustedSourceV2",
      "UniqueDevice",
      "User",
      "UserKey",
      "UserV2",
      "Vault",
      "Wallet",
      "WalletConnectSession",
      "WebhookEndpoint",
      "WebhookEvent",
      "WebhookEventType",
      "WebhookNotification",
      "WebhookSubscription"
    ],
    "Operation": [
      "AddOrganizationOperation",
      "AddTrustedDestinationOperation",
      "AddUserAndPoliciesOperation",
      "AuthorizeSpenderOperation",
      "BalanceAdjustmentOperation",
      "ChangeRoleOperation",
      "CreateVaultOperation",
      "DebitInOperation",
      "DebitInReturnOperation",
      "DebitOutOperation",
      "DebitOutReturnOperation",
      "DelegateOperation",
      "DepositEventOperation",
      "DepositOperation",
      "DisableVaultOperation",
      "GenericOperation",
      "GenericOrgChangeOperation",
      "LockOperation",
      "OffChainOperation",
      "OneOffOperation",
      "RemoveTrustedDestinationOperation",
      "RemoveUserAndPoliciesOperation",
      "ReplaceUserOperation",
      "TransferOperation",
      "UnlockOperation",
      "UpdateOrgPoliciesOperation",
      "UpdateVaultPoliciesOperation",
      "VoteOperation",
      "WireReturnOperation",
      "WithdrawOperation"
    ],
    "OperationField": [
      "SignedOperationField",
      "UnsignedOperationField"
    ],
    "PolicyAction": [
      "QuorumAction",
      "RuleAction"
    ],
    "PolicyFragment": [
      "PolicyStructuredFragment"
    ],
    "PolicyResource": [
      "Organization",
      "Vault"
    ],
    "PolicyV2WriteResult": [
      "PendingPolicyChange",
      "PolicyV2"
    ],
    "PresentationRule": [
      "PresentationRuleDontShowAgain",
      "PresentationRuleJustOnce"
    ],
    "QuoteResult": [
      "JupiterQuote",
      "UniswapClassicQuote",
      "UniswapXQuoteV2"
    ],
    "Resource": [
      "Organization",
      "Vault"
    ],
    "RolePermissionDestinationDetail": [
      "AMLBlockchainAddress",
      "TrustedDestination"
    ],
    "Rule": [
      "PolicyRuleV2",
      "QuorumRule"
    ],
    "RuleConditionComponentArgs": [
      "TrustedSmartContractMethodArgs"
    ],
    "RuleConditionParameter": [
      "RuleConditionMultiSelectParameter",
      "RuleConditionNumberParameter",
      "RuleConditionSelectParameter",
      "RuleConditionTextParameter"
    ],
    "RuleConditionParameterOptionIcon": [
      "RuleConditionProductIcon",
      "RuleConditionRemoteIcon"
    ],
    "RuleConditionSentenceElementContent": [
      "RuleConditionSentenceLiteralElementContent",
      "RuleConditionSentenceOperatorElementContent",
      "RuleConditionSentenceParameterElementContent",
      "RuleConditionSentenceTypeElementContent"
    ],
    "RuleOutcome": [
      "BlockOutcome",
      "QuorumOutcome"
    ],
    "SNAction": [
      "SNWalletSelectAction"
    ],
    "SNMatcher": [
      "SNCounterPartyAssetMatcher"
    ],
    "SettlementInstructions": [
      "SettlementInstructionsCrypto",
      "SettlementInstructionsFiat"
    ],
    "SignedOperationDetails": [
      "SignedOperationDetailsAccordion",
      "SignedOperationDetailsAddress",
      "SignedOperationDetailsAmount",
      "SignedOperationDetailsPreviewLayout"
    ],
    "StagedUser": [
      "APIStagedUser",
      "AppStagedUser"
    ],
    "StakingStep": [
      "AddressInputStep",
      "AmountInputStep",
      "AmountListStep",
      "AutoCompoundStep",
      "DurationInputStep",
      "InfoStep",
      "PercentageInputStep",
      "SelectInputStep",
      "ValidatorInputStep",
      "WalletSelectorStep"
    ],
    "TokenInfo": [
      "NftTokenInfo"
    ],
    "UnsignedOperationDetails": [
      "UnsignedOperationDetailsAddress",
      "UnsignedOperationDetailsAmount",
      "UnsignedOperationDetailsDelta",
      "UnsignedOperationDetailsDivider",
      "UnsignedOperationDetailsHighlight",
      "UnsignedOperationDetailsText",
      "UnsignedOperationDetailsTransaction"
    ],
    "ValidatorDetail": [
      "CeloValidatorGroupDetail",
      "NonAddressValidatorDetail",
      "OasisValidatorDetail"
    ],
    "VoteDetails": [
      "CeloProposalDetails",
      "MakerPollDetails",
      "MakerVoteDetails"
    ],
    "WalletDepositInstructions": [
      "BlockchainAddress",
      "DepositInstructions"
    ],
    "WalletKeyExportPreference": [
      "WalletKeyExportDownload",
      "WalletKeyExportEmail",
      "WalletKeyExportUnknown"
    ],
    "_commonAmount": [
      "Amount",
      "UnsupportedAssetAmount"
    ],
    "_commonAssetTypeInfo": [
      "AssetTypeInfo",
      "UnsupportedAssetAssetTypeInfo"
    ],
    "_commonNetworkInfo": [
      "NetworkInfo",
      "UnsupportedAssetNetworkInfo"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Actor": [
      "APIKeyV2",
      "AnchorageActor",
      "UnknownActor",
      "UserKey",
      "UserV2"
    ],
    "Button": [
      "BooleanButton"
    ],
    "EEAmount": [
      "Amount",
      "UnsupportedAssetAmount"
    ],
    "EEAssetTypeInfo": [
      "AssetTypeInfo",
      "UnsupportedAssetAssetTypeInfo"
    ],
    "EENetworkInfo": [
      "NetworkInfo",
      "UnsupportedAssetNetworkInfo"
    ],
    "ErrorMessage": [
      "OutstandingHoldsError"
    ],
    "FiatTrustedDestinationIntruction": [
      "FiatTrustedDestinationACHPullAuthorization",
      "FiatTrustedDestinationACHPush",
      "FiatTrustedDestinationInstantTransfer",
      "FiatTrustedDestinationWire"
    ],
    "IAMMember": [
      "IAMMemberUser"
    ],
    "IAMResource": [
      "Organization",
      "Vault"
    ],
    "Initiator": [
      "APIKey",
      "User"
    ],
    "Instruction": [
      "InstantTransferStandingInstruction",
      "WireStandingInstruction"
    ],
    "KYCProfile": [
      "AffiliateKYCProfile",
      "OrganizationKYCProfile",
      "RelatedPartyKYCProfile"
    ],
    "KYCProfileRelation": [
      "AffiliateKYCProfileRelation",
      "KYCProfileRelationAuditRole",
      "RelatedPartyKYCProfileRelation"
    ],
    "Key": [
      "APIKeyV2",
      "UserKey"
    ],
    "Node": [
      "APIKeyV2",
      "AccountConstraint",
      "AccountConstraintGroup",
      "AccountConstraintState",
      "AccountOrganizations",
      "AccountV2",
      "AddressBalance",
      "AffiliateAnchorageRelationship",
      "AffiliateV2",
      "AnchorageLegalEntity",
      "BlockchainAddress",
      "CRRScoreDetails",
      "ClientOrder",
      "ClientPaymentFlow",
      "ClientSettlement",
      "CounterpartyScreeningEntry",
      "DepositAttributionSpamThreshold",
      "DepositAttributionV2",
      "ExternalAccount",
      "ExternalAccountLocation",
      "ExternalAccountTransaction",
      "ExternalScreeningRequest",
      "GlobalTrustedSource",
      "IAMCategory",
      "IAMMemberUser",
      "IAMPermission",
      "IAMRole",
      "IAMUserAccess",
      "IAMUserRole",
      "IndividualAffiliateRelationshipAudit",
      "KYCConfig",
      "KYCProcess",
      "KYCProcessTrigger",
      "KYCQuestion",
      "KYCQuestionnaire",
      "KYCQuestionnaireSubmission",
      "KYCScreeningRequest",
      "KeyInfo",
      "MintBurnConversion",
      "NxtTfcAccount",
      "NxtTfcCycle",
      "NxtTfcPosition",
      "OrganizationModule",
      "PaymentFlow",
      "Person",
      "PolicyFragmentBinding",
      "PolicyQuorum",
      "ReadPolicy",
      "ReadQuorum",
      "Report",
      "ReportDataFilter",
      "ReportDataFilterValue",
      "ReportFile",
      "ReportFileEmailDelivery",
      "ReportFileSftpDelivery",
      "ReportFileSwiftDelivery",
      "ReportFileValidation",
      "ReportFileVerification",
      "ReportSchedule",
      "ReportScheduleDataFilter",
      "ReportScheduleDataFilterValue",
      "ReportScheduleEmailDestination",
      "ReportScheduleFileFormats",
      "ReportScheduleMainFilter",
      "ReportScheduleSftpDestination",
      "ReportScheduleSwiftDestination",
      "ReportTypeDefinition",
      "ReportTypeFilterDefinition",
      "ReportTypeHeader",
      "ReportTypeValidation",
      "SNParticipant",
      "SNTwoWaySettlement",
      "StablecoinRewardsParticipant",
      "TaxDocument",
      "TaxMapping",
      "TokenSwap",
      "TrustedSourceV2",
      "UniqueDevice",
      "User",
      "UserKey",
      "UserV2",
      "Vault",
      "Wallet",
      "WalletConnectSession",
      "WebhookEndpoint",
      "WebhookEvent",
      "WebhookEventType",
      "WebhookNotification",
      "WebhookSubscription"
    ],
    "Operation": [
      "AddOrganizationOperation",
      "AddTrustedDestinationOperation",
      "AddUserAndPoliciesOperation",
      "AuthorizeSpenderOperation",
      "BalanceAdjustmentOperation",
      "ChangeRoleOperation",
      "CreateVaultOperation",
      "DebitInOperation",
      "DebitInReturnOperation",
      "DebitOutOperation",
      "DebitOutReturnOperation",
      "DelegateOperation",
      "DepositEventOperation",
      "DepositOperation",
      "DisableVaultOperation",
      "GenericOperation",
      "GenericOrgChangeOperation",
      "LockOperation",
      "OffChainOperation",
      "OneOffOperation",
      "RemoveTrustedDestinationOperation",
      "RemoveUserAndPoliciesOperation",
      "ReplaceUserOperation",
      "TransferOperation",
      "UnlockOperation",
      "UpdateOrgPoliciesOperation",
      "UpdateVaultPoliciesOperation",
      "VoteOperation",
      "WireReturnOperation",
      "WithdrawOperation"
    ],
    "OperationField": [
      "SignedOperationField",
      "UnsignedOperationField"
    ],
    "PolicyAction": [
      "QuorumAction",
      "RuleAction"
    ],
    "PolicyFragment": [
      "PolicyStructuredFragment"
    ],
    "PolicyResource": [
      "Organization",
      "Vault"
    ],
    "PolicyV2WriteResult": [
      "PendingPolicyChange",
      "PolicyV2"
    ],
    "PresentationRule": [
      "PresentationRuleDontShowAgain",
      "PresentationRuleJustOnce"
    ],
    "QuoteResult": [
      "JupiterQuote",
      "UniswapClassicQuote",
      "UniswapXQuoteV2"
    ],
    "Resource": [
      "Organization",
      "Vault"
    ],
    "RolePermissionDestinationDetail": [
      "AMLBlockchainAddress",
      "TrustedDestination"
    ],
    "Rule": [
      "PolicyRuleV2",
      "QuorumRule"
    ],
    "RuleConditionComponentArgs": [
      "TrustedSmartContractMethodArgs"
    ],
    "RuleConditionParameter": [
      "RuleConditionMultiSelectParameter",
      "RuleConditionNumberParameter",
      "RuleConditionSelectParameter",
      "RuleConditionTextParameter"
    ],
    "RuleConditionParameterOptionIcon": [
      "RuleConditionProductIcon",
      "RuleConditionRemoteIcon"
    ],
    "RuleConditionSentenceElementContent": [
      "RuleConditionSentenceLiteralElementContent",
      "RuleConditionSentenceOperatorElementContent",
      "RuleConditionSentenceParameterElementContent",
      "RuleConditionSentenceTypeElementContent"
    ],
    "RuleOutcome": [
      "BlockOutcome",
      "QuorumOutcome"
    ],
    "SNAction": [
      "SNWalletSelectAction"
    ],
    "SNMatcher": [
      "SNCounterPartyAssetMatcher"
    ],
    "SettlementInstructions": [
      "SettlementInstructionsCrypto",
      "SettlementInstructionsFiat"
    ],
    "SignedOperationDetails": [
      "SignedOperationDetailsAccordion",
      "SignedOperationDetailsAddress",
      "SignedOperationDetailsAmount",
      "SignedOperationDetailsPreviewLayout"
    ],
    "StagedUser": [
      "APIStagedUser",
      "AppStagedUser"
    ],
    "StakingStep": [
      "AddressInputStep",
      "AmountInputStep",
      "AmountListStep",
      "AutoCompoundStep",
      "DurationInputStep",
      "InfoStep",
      "PercentageInputStep",
      "SelectInputStep",
      "ValidatorInputStep",
      "WalletSelectorStep"
    ],
    "TokenInfo": [
      "NftTokenInfo"
    ],
    "UnsignedOperationDetails": [
      "UnsignedOperationDetailsAddress",
      "UnsignedOperationDetailsAmount",
      "UnsignedOperationDetailsDelta",
      "UnsignedOperationDetailsDivider",
      "UnsignedOperationDetailsHighlight",
      "UnsignedOperationDetailsText",
      "UnsignedOperationDetailsTransaction"
    ],
    "ValidatorDetail": [
      "CeloValidatorGroupDetail",
      "NonAddressValidatorDetail",
      "OasisValidatorDetail"
    ],
    "VoteDetails": [
      "CeloProposalDetails",
      "MakerPollDetails",
      "MakerVoteDetails"
    ],
    "WalletDepositInstructions": [
      "BlockchainAddress",
      "DepositInstructions"
    ],
    "WalletKeyExportPreference": [
      "WalletKeyExportDownload",
      "WalletKeyExportEmail",
      "WalletKeyExportUnknown"
    ],
    "_commonAmount": [
      "Amount",
      "UnsupportedAssetAmount"
    ],
    "_commonAssetTypeInfo": [
      "AssetTypeInfo",
      "UnsupportedAssetAssetTypeInfo"
    ],
    "_commonNetworkInfo": [
      "NetworkInfo",
      "UnsupportedAssetNetworkInfo"
    ]
  }
};
      export default result;
    